import { DefaultSecondaryButton, Spinner } from '@frontend/components/common';
import { ICONS, QRCode } from '@frontend/icons';
import { CommonMessage } from '@frontend/lang';
import { FormattedMessage } from 'react-intl';

import WizardScreenContainer from '../../components/wizard-screen-container/wizard-screen-container.component';
import useFablabScanQrCode from './fablab-scan-qr-code.controller';

const ID = 'fablab-scan-qr-code';

const FablabScanQrCode = () => {
    const viewProps = useFablabScanQrCode();

    return (
        <WizardScreenContainer
            id={ID}
            header={{ title: CommonMessage.BUTTONS.DROP_OFF }}
            footer={{ onBack: viewProps.onBack }}
            errorModal={{
                show: !!viewProps.error,
                title: CommonMessage.ERRORS.DEFAULT,
                message: viewProps.error,
                onClose: viewProps.resetError
            }}
            containerClassName='bg-background-default flex flex-1 flex-col items-center justify-start gap-8 self-stretch overflow-y-scroll p-6 pb-20'>
            <div className='inline-flex items-center justify-center gap-3 self-stretch'>
                <div className='relative size-6 overflow-hidden'>
                    <QRCode className='text-always-black size-6' />
                </div>
                <div className='text-always-black justify-end text-lg font-medium'>
                    <FormattedMessage
                        id='kiosk.wizard.fablab-scan-qr-code.scan-qr-code'
                        defaultMessage='Scan QR code'
                        description='Heading on the FabLab QR code scanning screen'
                    />
                </div>
            </div>

            <div className='h-8 w-full' />

            <div className='flex flex-col items-center gap-5'>
                <div className='text-always-black justify-end text-center text-base font-medium'>
                    <FormattedMessage
                        id='kiosk.wizard.fablab-scan-qr-code.instructions'
                        defaultMessage='Scan your QR code if you have one.'
                        description='Instructions on the FabLab QR code scanning screen'
                    />
                </div>

                <div className='bg-brand-secondary flex size-24 items-center justify-center rounded-full'>
                    {viewProps.resolving && <Spinner className='text-border-default fill-brand-primary size-25' />}
                    <ICONS.BUTTON.ARROW_DOWN className='text-always-white absolute size-10' />
                </div>
            </div>

            <div className='mt-4 flex w-full justify-center'>
                <DefaultSecondaryButton
                    text={
                        <FormattedMessage
                            id='kiosk.wizard.fablab-scan-qr-code.no-qr-code'
                            defaultMessage="I don't have a QR code"
                            description='Button label on the FabLab QR code scanning screen for users who do not have a QR code'
                        />
                    }
                    onClick={viewProps.onNoQrCode}
                />
            </div>
        </WizardScreenContainer>
    );
};

export default FablabScanQrCode;
